function ButtonGreen({ title }: { title: any }) {
    return (
        <div className="relative">
            <button className='h-11 font-semibold text-sm rounded-xl w-full bg-green hover:animate-button-white'>{title}</button>
        </div>
    );
}

export default ButtonGreen;
